export const API_BASE_URL = 'https://sunshine.profession.trihorns.com';
export const HOUSE_IMAGE_API = `${API_BASE_URL}/api/houseImage`;